import React, {
  Component,
} from 'react';
import PropTypes from 'prop-types';
import { FaTooltipWrapper } from 'Components/UI/Tooltip';
import { MedicareInsurance as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import FieldList from '../Fields/FieldList';
import TextInput from '../Fields/TextInput';
import Section from '../Section';
import { getClientPicklistValue, shouldMakeNotesFieldReadOnly } from './Helpers/ClientPicklist';
import SelectInput from '../Fields/SelectInput';

class MedicareInsuranceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      medicareInsuranceInsuredClientId: '',
    };

    this.onChange = this.onChange.bind(this);
    this.getAccountName = this.getAccountName.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getAccountName() {
    const { insuredClientOptions } = this.props;
    const { medicareInsuranceInsuredClientId } = this.state;
    return getClientPicklistValue(insuredClientOptions, medicareInsuranceInsuredClientId) || 'New coverage';
  }

  render() {
    const {
      getAccountName,
      onChange,
      props: {
        id, insuredClientOptions, children: removeButton, expanded,
      },
      state: { medicareInsuranceInsuredClientId },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getAccountName()}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <SelectInput
          label="Insured"
          name={`medicareInsuranceInsuredClientId.${id}`}
          options={insuredClientOptions}
          answerKey="medicareInsuranceInsuredClientId"
          onChange={(name, value) => onChange('medicareInsuranceInsuredClientId', value)}
        />
        <TextInput
          placeholder="Insured Notes"
          name={`medicareInsuranceInsuredNotes.${id}`}
          answerKey="medicareInsuranceInsuredNotes"
          onChange={(name, value) => onChange('medicareInsuranceInsuredNotes', value)}
          readOnly={shouldMakeNotesFieldReadOnly(medicareInsuranceInsuredClientId)}
        />
        <FaTooltipWrapper title="e.g. Medicare parts A, B, D and Medigap F">
          <TextInput
            placeholder="Details"
            name={`medicareInsuranceDetails.${id}`}
            answerKey="medicareInsuranceDetails"
          />
        </FaTooltipWrapper>
      </LabeledVerticalExpander>
    );
  }
}

MedicareInsuranceList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  insuredClientOptions: PropTypes.array.isRequired,
};

MedicareInsuranceList.defaultProps = {
  expanded: false,
};

const MedicareInsurance = ({ insuredClientOptions }) => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      transitionSpeed={0.25}
      height={400}
      title="Medicare"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
    >
      <FieldList
        onCountUpdate={setCount}
        label="Policy - medicare"
        addLabel="Add a coverage"
        keyPrefix="medicareInsurances"
        Of={MedicareInsuranceList}
        childProps={{ insuredClientOptions }}
      />
    </Section>
  );
};

MedicareInsurance.propTypes = {
  insuredClientOptions: PropTypes.array.isRequired,
};

export default MedicareInsurance;
